import axios from '../plugins/axios';

const API_URL = '/admin';

export default {
  async login(credentials) {
    try {
      console.log('Login request with credentials:', credentials);
      const response = await axios.post(`${API_URL}/login`, credentials);
      console.log('Login API response:', response.data);
      
      // Ensure the response has the expected structure
      if (!response.data.data) {
        console.warn('Login response missing data property:', response.data);
        // Try to adapt the response to the expected format
        return {
          data: {
            user: response.data.user || { 
              name: 'User',
              role: 'admin' // Default role for testing
            },
            token: response.data.token || response.data.access_token
          }
        };
      }
      
      return response;
    } catch (error) {
      console.error('Login API error:', error);
      throw error;
    }
  },
  
  async logout() {
    try {
      const response = await axios.post(`${API_URL}/logout`);
      
      // Remove the token
      delete axios.defaults.headers.common['Authorization'];
      
      return response;
    } catch (error) {
      console.error('Logout error:', error);
      throw error;
    }
  },
  
  async getUserPermissions() {
    try {
      const response = await axios.get(`${API_URL}/user/permissions`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user permissions:', error);
      throw error;
    }
  },
  
  setAuthHeader(token) {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }
}; 